import { get } from "@src/appV2/api/api";
import { APP_V2_APP_EVENTS } from "@src/appV2/lib";
import {
  useMutation,
  type UseMutationOptions,
  type UseMutationResult,
} from "@tanstack/react-query";
import { type AxiosError } from "axios";
import { z } from "zod";

import { SEND_CHECKR_APPLICATION_URL } from "./constants";

const checkrApplicationStatusSchema = z.object({
  invitationStatus: z.string().optional(),
  reportStatus: z.string().optional(),
  invitationUrl: z.string().optional(),
});

export const checkrApplicationStatusResponseSchema = z.object({
  data: checkrApplicationStatusSchema,
});

export type CheckrApplicationStatusResponse = z.infer<typeof checkrApplicationStatusResponseSchema>;

export function useSendCheckrInvitation(
  options: UseMutationOptions<CheckrApplicationStatusResponse, AxiosError> = {}
): UseMutationResult<CheckrApplicationStatusResponse, AxiosError, void> {
  return useMutation({
    mutationKey: [SEND_CHECKR_APPLICATION_URL],
    mutationFn: async () => {
      const response = await get({
        url: SEND_CHECKR_APPLICATION_URL,
        responseSchema: checkrApplicationStatusResponseSchema,
      });

      return response.data;
    },
    meta: {
      logErrorMessage: APP_V2_APP_EVENTS.RESEND_CHECKR_INVITATION_FAILURE,
    },
    ...options,
  });
}
